module.exports = __webpack_public_path__ + "static/media/22ESCWA21.6d9b2466.jpg";